module.exports = __webpack_public_path__ + "img/vertical_6_3_7042.4df4fbc2.png";